export const ORDER_STATUS_CREATED = "CREATED";
export const ORDER_STATUS_PAYMENT_PENDING = "PAYMENT_PENDING";
export const ORDER_STATUS_PAID = "PAID";
export const ORDER_STATUS_READY_FOR_SHIPPING = "READY_FOR_SHIPPING";
export const ORDER_STATUS_PICKED_UP = "PICKED_UP";
export const ORDER_STATUS_IN_TRANSIT = "IN_TRANSIT";
export const ORDER_STATUS_DELIVERED = "DELIVERED";
export const ORDER_STATUS_COMPLETED = "COMPLETED";
export const ORDER_STATUS_RETURNED = "RETURNED";
export const ORDER_STATUS_RECEIVED = "RECEIVED";

// Purchase Order Statuses
export const PURCHASE_ORDER_STATUS_DRAFT = "draft";
export const PURCHASE_ORDER_STATUS_ORDERED = "ordered";
export const PURCHASE_ORDER_STATUS_PENDING_CONFIRMATION = "pending_confirmation";
export const PURCHASE_ORDER_STATUS_PENDING_APPROVAL = "pending_approval";
export const PURCHASE_ORDER_STATUS_PENDING_SUPPLIER_REVIEW = "pending_supplier_review";
export const PURCHASE_ORDER_STATUS_PAYMENT_PENDING = "payment_pending"; // DEPRECATED: Use PURCHASE_ORDER_PAYMENT_STATUS_PENDING instead
export const PURCHASE_ORDER_STATUS_DEPOSIT_PAID = "deposit_paid"; // DEPRECATED: Use PURCHASE_ORDER_PAYMENT_STATUS_DEPOSIT_PAID instead
export const PURCHASE_ORDER_STATUS_PAID = "paid"; // DEPRECATED: Use PURCHASE_ORDER_PAYMENT_STATUS_PAID instead
export const PURCHASE_ORDER_STATUS_READY_FOR_PRODUCTION = "ready_for_production";
export const PURCHASE_ORDER_STATUS_IN_PRODUCTION = "in_production";
export const PURCHASE_ORDER_STATUS_SHIPPED = "shipped";
export const PURCHASE_ORDER_STATUS_RECEIVED = "received";
export const PURCHASE_ORDER_STATUS_UNDER_REVIEW = "under_review";
export const PURCHASE_ORDER_STATUS_COMPLETED = "completed";
export const PURCHASE_ORDER_STATUS_CANCELLED = "cancelled";
export const PURCHASE_ORDER_STATUS_SPLIT = "split";

// Purchase Order Payment Statuses (separate from order status)
export const PURCHASE_ORDER_PAYMENT_STATUS_PENDING = "payment_pending";
export const PURCHASE_ORDER_PAYMENT_STATUS_DEPOSIT_PAID = "deposit_paid";
export const PURCHASE_ORDER_PAYMENT_STATUS_PAID = "paid";

// Shop Order Payment Statuses
export const PAYMENT_STATUS_NOT_SENT = "not_sent";
export const PAYMENT_STATUS_SENT = "sent";
export const PAYMENT_STATUS_PAID = "paid";
export const PAYMENT_STATUS_REFUNDED = "refunded";
export const PAYMENT_STATUS_OVERDUE = "overdue";

// Product Draft Statuses
export const PRODUCT_DRAFT_STATUS_NEEDS_SUPPLIER_INPUT = "needs_supplier_input";
export const PRODUCT_DRAFT_STATUS_SUBMITTED = "submitted";
export const PRODUCT_DRAFT_STATUS_CHANGES_REQUESTED = "changes_requested";
export const PRODUCT_DRAFT_STATUS_APPROVED = "approved";
export const PRODUCT_DRAFT_STATUS_PUBLISHED = "published";
